import * as appSettings from '../environments/environment';

export const APP_SETTINGS_JSON = (appSettings as any).default;
